import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from '../../_services/admin.service';
import { PRODUCT_CONFIG, FORM_MSGS, ADMIN_UTILITY, RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { UserStatusID, CustomInputType, StatusCode } from 'src/app/_common/_enum/module.enum';
import { NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;

  private resultsNotFound = RESULTS_NOT_FOUND;
  private canEdit: boolean = true;
  private loading: boolean = false;
  private updating: boolean = false;
  private deactivating: boolean = false;

  private errorMessage:string = '';
  private productConfig = PRODUCT_CONFIG;
  private formMsgs = FORM_MSGS;
  private adminMsgs = ADMIN_UTILITY;
  
  private allUserType = [
    {displayName: "ProSight", value: 1},
    {displayName: "Vendor", value: 2},
    {displayName: "Agent", value: 3},
    {displayName: "Retailer", value: 4},
    {displayName: "Policyholder", value: 5},
    {displayName: "Insured", value: 6}];
  
  private selectedUserType = this.allUserType[0];

  private allUserRole = [
    {displayName: "Super Admin", value: 1},
    {displayName: "Site Admin", value: 2},
    {displayName: "Site Contributor", value: 3},
    {displayName: "Company Admin", value: 4},
    {displayName: "Super User", value: 5},
    {displayName: "User", value: 6}];
    
  private selectedUserRole = this.allUserRole[0];

  private allManagerRole = [
    "Coaction Underwriter", 
    "Coaction Business Manager"
  ];

  private selectedManagerRole = this.allManagerRole[0];
  
  private oktaID = null;
  private user = null;
  private companyList = null;
  private selectedCompany = null;

  private modalReference;
  private hasAccess:boolean = false;

  private customInputTypes = CustomInputType; //using in HTML

  @ViewChild("deactivateUserModal", {static: false}) deactivateUserModal;
  constructor(private readonly route: ActivatedRoute, private router: Router, private adminService: AdminService, private changeDetectorRef : ChangeDetectorRef, private modalService : NgbModal) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */
    this.loading = true;

    //Getting Okta ID for State params
    this.route.paramMap.subscribe(params => {
      this.oktaID = params.get("id").toString();
      this.fetchUserDetails();
    });
  }
  setHeaderData(){
    this.headerData.pageTitle = (this.user)?(this.user.firstName + " " + this.user.lastName):"";
    this.headerData.breadcrumb = [{itemName: "ADMIN", itemLink: "/admin"}];
    if(this.user){
      this.headerData.breadcrumb.push({itemName: this.user.companyName, itemLink: "/admin/company/"+ this.user.companyID})
    }
    this.adminService.header = this.headerData;  
  }
  get UserStatusIDEnum(){
    return UserStatusID;
  }
  fetchUserDetails(){
    this.loading = true;
    let userDetailsSubscription = this.adminService.fetchUserDetails(this.oktaID).subscribe((user:any)=>{
      this.loading = false;
      this.user = user;
      if(this.user.statusID != UserStatusID.Active && this.user.statusID != UserStatusID.PendingActivation){
        this.user = null;
        this.canEdit = false;
        console.log("You cannot edit " + this.user.statusDesc + " user");
      }else{
        this.canEdit = true;
        this.setHeaderData();  

        this.selectedCompany = {companyID: user.companyID, companyName: user.companyName, producerCodes: user.producerCodesArray, producerCodesArray: user.companyProducerCodes};
          
        let newProducerCodes = [];
        this.selectedCompany.producerCodesArray.forEach(_producerCode => {
          newProducerCodes.push({code: _producerCode, isSelected: this.user.producerCodes.includes(_producerCode)});
        });

        this.user.companyProducerCodesArray = newProducerCodes;
        
        this.selectedUserType = this.allUserType.find((_type)=>{return _type.value == this.user.userTypeID});
        this.selectedUserRole = this.allUserRole.find((_role)=>{return _role.value == this.user.userRoleID});
        this.selectedManagerRole = this.allManagerRole.find((_role)=>{return _role == this.user.PSOPUserManagerRole});
        console.log(this.selectedCompany);
        this.companyList = [this.selectedCompany];
      }
    },error=>{
      this.loading = false;
      this.user = null;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });
    this.adminService.runningServices.push(userDetailsSubscription);
  }
  
  selectUserRole(_userRoleID){
    this.selectedUserRole = this.allUserRole.find((_role)=>{return _role.value == _userRoleID});
  }

  selectManagerRole(_managerRole){
    this.selectedManagerRole = this.allManagerRole.find((_role)=>{return _role == _managerRole});
  }

  selectAllProducers(_isSelect){
    this.user.companyProducerCodesArray.forEach(producerCode => {
      producerCode.isSelected = _isSelect;
    });
  }

  ngAfterViewChecked() {
    if(this.user && this.selectedCompany != this.user.selectedCompany){
      if(this.companyList && this.companyList.length> 0){
        this.selectedCompany = this.companyList.find(_company=>{return _company.companyID == this.user.companyID});
      }
      this.changeDetectorRef.detectChanges();
    }
  }
  
  editUser(_updateUserForm: NgForm) {
    this.user.producerCodes = [];
      this.user.companyProducerCodesArray.forEach(_code => {
        if(_code.isSelected){
          this.user.producerCodes.push(_code.code);
        }
      });
    if(_updateUserForm.valid && (this.user.companyProducerCodesArray==0 || this.user.producerCodes.length>0)){
      console.log("form is valid to create user");
      /*this.user.producers = [];
      this.user.companyProducerCodesArray.forEach(_code => {
        if(_code.isSelected){
          this.user.producers.push(_code.code);
        }
      });
      this.user.producers.join(",");*/
      this.user.phone = this.user.primaryPhone;

      this.resetAlertMessages();
      this.updating = true;
      let updateUserSubscription = this.adminService.updateUser(this.user).subscribe(data => {
        this.updating = false;
        this.router.navigateByUrl('admin/user/' + this.user.oktaUID);
      },
      error => {
          this.errorMessage = FORM_MSGS.SomethingWentWrong;
          this.updating = false;
      });
      this.adminService.runningServices.push(updateUserSubscription);
    }

  }

  onDeactivate(){
    this.modalReference = this.modalService.open(this.deactivateUserModal, { centered: false, backdropClass: 'light-blue-backdrop' });
    this.modalReference.result.then((result) => {
      console.log("closed");
      }, (reason) => {
        console.log("dismissed");
    });
  }

  deactivateUser(){
    console.log("deacitvate user");
    this.modalReference.close();
    this.deactivating = true;
    let deactivateUserSubscription = this.adminService.deactivateUser({"OktaUID": this.user.oktaUID}).subscribe(data => {
      this.deactivating = false;
      this.router.navigateByUrl('admin/user/' + this.user.oktaUID);
    },
    error => {
        this.errorMessage = FORM_MSGS.SomethingWentWrong;
        this.deactivating = false;
    });
    this.adminService.runningServices.push(deactivateUserSubscription);
  }
  resetAlertMessages(){
    this.errorMessage = "";
  }
  ngOnDestroy() {
    this.adminService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
